// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view-settings-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-tertiary);
  cursor: pointer;
  user-select: none;
}

.view-settings-row:last-child {
  border-bottom: none;
}

.view-settings-row:hover {
  background: var(--color-brand-hover2, #f9e2d6);
}

.view-settings-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  color: var(--text-secondary);
}

.view-settings-icon svg {
  width: 24px;
  height: 24px;
}

.view-settings-icon svg path {
  fill: var(--accent-secondary);
}

.view-settings-row-active .view-settings-icon svg path {
  fill: var(--color-brand);
}

@container (max-width: 600px) {
  .view-settings-popup {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/AdvanceChartWidget/components/settings/ViewSettings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".view-settings-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-tertiary);\n  cursor: pointer;\n  user-select: none;\n}\n\n.view-settings-row:last-child {\n  border-bottom: none;\n}\n\n.view-settings-row:hover {\n  background: var(--color-brand-hover2, #f9e2d6);\n}\n\n.view-settings-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n  color: var(--text-secondary);\n}\n\n.view-settings-icon svg {\n  width: 24px;\n  height: 24px;\n}\n\n.view-settings-icon svg path {\n  fill: var(--accent-secondary);\n}\n\n.view-settings-row-active .view-settings-icon svg path {\n  fill: var(--color-brand);\n}\n\n@container (max-width: 600px) {\n  .view-settings-popup {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
